import { useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../reducers';
import { siteNavOptions } from './LeftSidebar/NavOptions';
import SidebarList from './SideBars/SideBarList';

export const CLIENT_AND_SITE_FROM_HOST_REGEX: RegExp =
    // eslint-disable-next-line
    /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})-([0-9a-zA-Z_]{1,16})(-([0-9a-zA-Z_]{1,16}))?-sites(-([0-9a-zA-Z_]{1,16}))?/i;

const TopBar: any = () => {
    const { environmentList } = useSelector((state: ReduxStateShape) => ({
        ...state.templateEditor,
        environmentList: state.envDiff.listItems,
    }));

    const hostname = window.location.hostname;
    const match = CLIENT_AND_SITE_FROM_HOST_REGEX.exec(hostname) || [];

    const handleChangeEnvironment = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const targetEnv = e.currentTarget.value;
        const domain = hostname.split('.').slice(1).join('.');
        const { protocol, pathname } = window.location;
        const clientId = match[1];
        const siteId = match[2];
        const deployment = match[6];

        if (!clientId || !siteId) {
            return;
        }

        const url = `${protocol}//${clientId}-${siteId}-${targetEnv}-sites${
            deployment ? `-${deployment}` : ''
        }.${domain}${pathname}`;

        window.location.href = url;
    };

    let loadedEnvironment = match[4] || '';

    if (!loadedEnvironment) {
        loadedEnvironment = environmentList?.find((e) => e.path === 'production')?.id || '';
    }

    return (
        <>
            <div className={'topbar'}>
                <div className={'environment-top-side-bar-container'}>
                    <div className="top-side-bar-pill">
                        <SidebarList options={siteNavOptions} />
                    </div>
                    <div className="environment">
                        <select className="environment-selector" onChange={handleChangeEnvironment}>
                            {environmentList?.map((e) => (
                                <option
                                    selected={e.id === loadedEnvironment}
                                    value={e.id}
                                >{`${e.id} (${e.path})`}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopBar;
